var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dialogue", {
        attrs: {
          title: "Success",
          paragraph: _vm.save_dialogue_text,
          button_names: ["Accept"],
          show: _vm.save_dialogue,
          autoClose: false
        },
        on: { dialogue: _vm.saveDialogue, cancel: _vm.saveDialogueCancel }
      }),
      _vm._v(" "),
      _c("dialogue", {
        attrs: {
          title: "Resolve Troubleticket",
          paragraph: _vm.resolve_dialogue_text,
          button_names: ["Accept", "Download Files"],
          show: _vm.resolve_dialogue,
          autoClose: false,
          html: _vm.resolve_html
        },
        on: { dialogue: _vm.resolveDialogue, cancel: _vm.resolveDialogueCancel }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "margin-left": "25px", "margin-right": "25px" }
          }),
          _vm._v(" "),
          _c("table", [
            _vm._m(1),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { staticStyle: { width: "100%" }, attrs: { colspan: "2" } },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.issue,
                        expression: "issue"
                      }
                    ],
                    staticClass: "textfield",
                    attrs: { placeholder: "write issue here" },
                    domProps: { value: _vm.issue },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.issue = $event.target.value
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { staticStyle: { width: "100%" }, attrs: { colspan: "2" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.system,
                        expression: "system"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    domProps: { value: _vm.system },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.system = $event.target.value
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _c("b-form-file", {
            staticClass: "upload-box text-nowrap text-truncate",
            class: { unselectable: _vm.save_dialogue || _vm.resolve_dialogue },
            attrs: {
              size: "lg",
              state: Boolean(_vm.uploadFiles),
              placeholder: "Choose or Drop files here",
              "drop-placeholder": "Drop files here",
              multiple: "",
              disabled: _vm.save_dialogue || _vm.resolve_dialogue
            },
            on: {
              input: function($event) {
                return _vm.select()
              }
            },
            model: {
              value: _vm.uploadFiles,
              callback: function($$v) {
                _vm.uploadFiles = $$v
              },
              expression: "uploadFiles"
            }
          }),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "margin-left": "25px", "margin-right": "25px" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_vm._v("Submit")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "uploading-box",
              class: { hidden: !_vm.loading },
              staticStyle: { "margin-bottom": "10px" }
            },
            [
              _c("div", {
                staticClass: "uploading-bar-green",
                style: "width:" + _vm.loadingBarWidth + "%",
                attrs: { id: "loading-progress" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "uploading-box",
              class: { hidden: !_vm.uploading },
              staticStyle: { "margin-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticClass: "uploading-bar", attrs: { id: "progress" } },
                [
                  _c("p", {
                    staticClass: "upload-text",
                    attrs: { id: "progress-text" }
                  })
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.perms.includes("101")
        ? _c("layout-1", {
            key: _vm.updateKey,
            staticStyle: { width: "100%", height: "calc(100vh - 690px)" },
            attrs: {
              table_name: "Troubletickets",
              id: _vm.pageid,
              searchbar: true,
              collapseable: true,
              navbar: false,
              term: _vm.term,
              button_perm: "101",
              button_name: "Edit"
            },
            on: { select: _vm.resolveIssue }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Submit Troubleticket")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "100%" }, attrs: { colspan: "2" } }, [
        _c("b", [_vm._v("Summary")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "100%" }, attrs: { colspan: "2" } }, [
        _c("b", [_vm._v("System")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "100%" }, attrs: { colspan: "2" } }, [
        _c("b", [_vm._v("Related Files")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bc57196", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc57196","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add/Add_Issues.vue
// module id = 674
// module chunks = 0